import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { KnownIssuePage } from 'src/app/model/page/group/known-issues/known-issue-table';
import { ApiService } from 'src/app/service/api.service';
import { CommonService } from 'src/app/service/common.service';

@Component({
  selector: 'app-known-issues-details-page',
  templateUrl: './known-issues-details-page.component.html',
  styleUrls: ['./known-issues-details-page.component.scss']
})
export class KnownIssuesDetailsPageComponent implements OnInit {
  @Output() back = new EventEmitter<void>();
  @Input() item!: KnownIssuePage;
  @Output() itemSelected = new EventEmitter<{ event: Event; item: any }>();

  key: string = '';
  keyDetails: KnownIssuePage[] = [];
  showKnownDetails: boolean = false;
  constructor(private dataService: CommonService, private apiService: ApiService, private route: ActivatedRoute) { }
  ngOnInit() { }

  async onSelectItem(event: Event, item: KnownIssuePage) {
    event.preventDefault();
    this.itemSelected.emit({ event, item });
    for (const key in item) {
      if (Object.prototype.hasOwnProperty.call(item, key)) {
      }
    }
  }

  displayErrorMsg(errorMsg: string | any[]): string {
    if (!errorMsg || (Array.isArray(errorMsg) && errorMsg.length === 0)) {
      return 'n/a';
    } else {
      return errorMsg as string;
    }
  }

  onBack() {
    this.back.emit();
  }
}